import React from 'react'
import userApi from 'src/api/userApi'
import { getFullName } from 'src/libs/util'

import { useGetData } from 'src/hooks/useGetData'
import Link from 'next/link'
import { URL_TEMPLATE } from 'src/libs/constant'

const isUserId = (id) => {
  return Boolean((`${id || ''}`.match(/^\d+$/gi)) && (`${id || ''}`).length < 9)
}

export function UsernameById ({ id, fullName }) {
  const createByIsId = isUserId(id)
  const { data } = useGetData(userApi.detail, id, { isDisabled: !id || !createByIsId })
  if (fullName && data) {
    return <>{getFullName(data) || data?.userName}</>
  }
  return (
    <>{data?.userName || id}</>
  )
}
export function UsernameById1 ({ id, useHook, fullName }) {
  const createByIsId = isUserId(id)
  const { data } = useHook(`GET_USER_BY_ID_${id}`, userApi.detail, id, { isDisabled: !id || !createByIsId })
  if (fullName && data) {
    return <>{getFullName(data) || data?.userName}</>
  }
  return (
    <>{data?.userName || id || ''}</>
  )
}

export function UsernameByIdLink ({ id, useHook, userInfoUrl = URL_TEMPLATE.MANAGE_USER_DETAIL }) {
  const createByIsId = isUserId(id)
  const { data } = useHook(`GET_USER_BY_ID_${id}`, userApi.detail, id, { isDisabled: !id || !createByIsId })

  return (
    data?.userName ? <Link href={`${userInfoUrl}?id=${id}`}>{data?.userName || id || ''}</Link> : <>{data?.userName || id || ''}</>
  )
}

export function UsernameByIdLinkOpenNewTag ({ id, useHook, userInfoUrl = URL_TEMPLATE.MANAGE_USER_DETAIL }) {
  const createByIsId = isUserId(id)
  const { data } = useHook(`GET_USER_BY_ID_${id}`, userApi.detail, id, { isDisabled: !id || !createByIsId })

  return (
    data?.userName ? <Link href={`${userInfoUrl}?id=${id}`}><a target='_blank'>{data?.userName || id || ''}</a></Link> : <>{data?.userName || id || ''}</>
  )
}

